import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconProjects: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconProjects"><Path d="M6.5 3.5H17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 6.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 9.5H2.5L4.5 20.5H19.5L21.5 9.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconProjects;
